import BaseOption from "./base-checkbox/BaseOption";
import PriceQuantity, { QuantityContor } from "./base-checkbox/PriceQuantity";

interface Props {
  checked: boolean;
  toggleOption: () => void;
  is_multi_select?: boolean;
  label: string;
  value?: number;
  disabled?: boolean;
  quantityContor?: QuantityContor;
  outOfStock?: boolean;
  disableRemoveAddon?: boolean;
  alloweSelectOutOfStock?: boolean;
}

const CheckboxOption: React.FC<Props> = ({
  checked,
  toggleOption,
  is_multi_select,
  label,
  value,
  disabled = false,
  quantityContor,
  outOfStock,
  disableRemoveAddon,
  alloweSelectOutOfStock,
}) => {
  const disabledAndChecked = checked && disableRemoveAddon;
  const disableOption = disabled || outOfStock || disableRemoveAddon;

  return (
    <li
      onClick={
        checked && !disableRemoveAddon
          ? quantityContor
            ? (e) => e.stopPropagation()
            : toggleOption
          : !disableOption || alloweSelectOutOfStock
          ? toggleOption
          : undefined
      }
      className={`add-on ${
        checked ? "selected" : disableOption ? "disabled" : ""
      } ${disableRemoveAddon || alloweSelectOutOfStock ? "disabled" : ""} ${
        (checked && quantityContor) || outOfStock
          ? "add-on-selected-qyantity-section"
          : ""
      }`}
    >
      <BaseOption
        selected={checked}
        disabled={disableOption}
        toggleOption={
          checked && quantityContor && !disableRemoveAddon
            ? toggleOption
            : () => {}
        }
        is_multi_select={is_multi_select!}
        label={label}
        disabledAndChecked={disabledAndChecked}
        alloweSelectOutOfStock={alloweSelectOutOfStock}
      />
      {(value || quantityContor) && (
        <PriceQuantity
          price={value}
          quantityContor={quantityContor}
          checked={checked}
          outOfStock={outOfStock!}
          disabled={disabledAndChecked}
          is_multi_select={is_multi_select!}
        />
      )}
    </li>
  );
};

export default CheckboxOption;
